/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Session_Not_FoundInputs */

const en_error_session_not_found = /** @type {(inputs: Error_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That session has already ended.`)
};

/**
* | output |
* | --- |
* | "That session has already ended." |
*
* @param {Error_Session_Not_FoundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_session_not_found = /** @type {((inputs?: Error_Session_Not_FoundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Session_Not_FoundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_session_not_found(inputs)
});